<template>
    <div class="section">
        <b-loading :is-full-page="true" :active.sync="loading" :can-cancel="true"></b-loading>
        <div v-if="!cart.totalInUy" class="div columns">
            <div class="column is-full empty-message-column has-text-centered">
                <img width="400px" src="https://traction-prod.ams3.digitaloceanspaces.com/static/assets/img/emptyCart.png" alt="">
                <p class="title is-size-3">No tienes nada en el carrito</p>
            </div>
        </div>

        <div v-else class="columns is-centered">
            <div class="column is-two-thirds">
                <b-table
                :data=cart.items
                :loading="loading">
                    <template slot-scope="props">
                        <b-table-column field="" labe="Eliminar" width="50">
                            <a 
                            class="has-text-danger"
                            @click="deleteCartItem(props.row)">
                                <b-icon icon="trash"></b-icon>
                            </a>
                        </b-table-column>
                        <b-table-column label="Imagen">
                            <img width="120px" :src="props.row.image" alt="">
                        </b-table-column>
                        <b-table-column field="productTitle" label="Producto" >
                            {{ props.row.productTitle }}
                        </b-table-column>
                        <b-table-column field="valueNames" label="Valores">
                        <p>
                            <span v-for="(val, i) in props.row.valueNames" :key="i">{{val}}, </span>
                        </p>
                        </b-table-column>
                        <b-table-column field="unitPrice" label="Precio unidad">
                            {{props.row.currencySymbol}}{{props.row.unitPrice}}
                        </b-table-column>
                        <b-table-column field="quantity" label="Cantidad" >
                            <b-field>
                                <b-numberinput
                                min="1"
                                type="is-light"                                        
                                v-model="props.row.quantity"
                                @input="updateCartItem(props.row)">
                                </b-numberinput>
                            </b-field>
                        </b-table-column>
                        <b-table-column field="total" label="Total">
                            {{props.row.currencySymbol}}{{props.row.total}}
                        </b-table-column>
                        <b-table-column field="totalInUy" label="Total en UY">
                            UY${{props.row.totalInUy}} 
                        </b-table-column>
                        
                    </template>
                </b-table>
            
                <div class="container m-t-20">
                    <div class="level has-text-left is-mobile">
                        <div class="level-item">
                            <div>
                                <p class="heading">Subtotal</p>
                                <p>UY${{cart.subtotalTaxInUy[0]}}</p>
                            </div>
                        </div>
                        <div class="level-item">
                            <div>
                                <p class="heading">Impuesto</p>
                                <p>UY${{cart.subtotalTaxInUy[1]}}</p>
                            </div>
                        </div>
                        <div class="level-item">
                            <div>
                                <p class="heading"><strong>Total</strong></p>
                                <p><strong>UY${{cart.totalInUy}}</strong> </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="has-text-centered m-t-10">
                    <a :href="checkoutTemplate"
                    class="button is-custom is-rounded">
                        Terminar compra. 
                        <b-icon class="m-l-5" icon="arrow-right" size="is-small"></b-icon>
                    </a>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {getHandler, debounce, patchHandler, deleteHandler} from "./../../../services/http"
export default {
    props:{
        cartDetailUrl:{
            type:String,
            default:""
        },
        checkoutTemplate:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            cart:{},
            loading:false,
        }
    },
    methods:{
        async fetchCartDetails(){
            this.loading = true
            this.cart = await getHandler(this.cartDetailUrl, {error:false, success:false})

            this.cart.items.forEach((el)=>{
                el.quantity = parseInt(el.quantity)
            })
            localStorage.setItem("cartCount", this.cart.itemCount)
            var event = document.createEvent("Event");
            event.initEvent("storage", true, true);
            window.dispatchEvent(event);
            this.loading = false
        },
        async deleteCartItem(item){
            var err={
                resource:"toast",
                text:"Algo salio mal... intentalo otra vez"
            }
            var succ={
                resource:"toast",
                text:"Producto eliminado del carro."
            }
            
            var resp = await deleteHandler(item.getDetailRestUrl, {error:err, success:succ})
            this.fetchCartDetails()
            
        },
        updateCartItem: debounce(

           async function(item,context=this){
               var err={
                    resource:"toast",
                    text:"Algo salio mal... intentalo otra vez"
                }
                var succ={
                    resource:"toast",
                    text:"Producto actualizado con exito."
                }
                if(item.quantity > 0){
                    let res = await patchHandler(item.getDetailRestUrl, item, {error:err, success:succ})
                    console.log(res)
                    if (res.status == 200 || res.status == 201){
                        this.fetchCartDetails()
                    }
                }
           }, 300
        )

    },
    created(){
        this.fetchCartDetails()
    }
}
</script>

<style lang="scss" scoped>


.card{
    border:0px #fff solid !important;
    border-radius: 20px;
    box-shadow: 1px 10px 10px rgba(184, 184, 184, 0.55);
}

.is-custom{
    background:var(--primary);
    color:var(--text-color);
}

.empty-message-column{
    padding:2rem 6rem;
    .cart-icon{
        margin-top:30px;
        color:var(--primary);
        transform: rotate(180deg) scaleX(-1);
        font-size: 5rem;
    }
}


</style>